/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Registrationemailfailederror3Inputs */

const en_registrationemailfailederror3 = /** @type {(inputs: Registrationemailfailederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't send the email. Please try again.`)
};

const de_registrationemailfailederror3 = /** @type {(inputs: Registrationemailfailederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die E-Mail konnte nicht gesendet werden. Bitte versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "We couldn't send the email. Please try again." |
*
* @param {Registrationemailfailederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const registrationemailfailederror3 = /** @type {((inputs?: Registrationemailfailederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Registrationemailfailederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_registrationemailfailederror3(inputs)
	return de_registrationemailfailederror3(inputs)
});
export { registrationemailfailederror3 as "registrationEmailFailedError" }